// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"055313577d93f4a55d57","655":"cec9071ba47e7f05bebc"}[chunkId] + ".js";
};